import { render, staticRenderFns } from "./BvaDefaultAvatars.vue?vue&type=template&id=511b8014&scoped=true&"
import script from "./BvaDefaultAvatars.vue?vue&type=script&lang=ts&"
export * from "./BvaDefaultAvatars.vue?vue&type=script&lang=ts&"
import style0 from "./BvaDefaultAvatars.vue?vue&type=style&index=0&id=511b8014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b8014",
  null
  
)

export default component.exports